import env from '../env';
import store from './vuex/store';

export default {
  sistema: {
    nome: 'Central do Servidor',
    sigla: 'Central',
    descricao: 'Tudo para o servidor num só lugar.',
  },

  isAuthenticated: !!store.state.token,
  publicPath: env.publicPath,
  apiUrl: env.apiUrl,
  apiEnderecoUrl: env.apiEnderecoUrl,
  staticUrl: env.staticUrl,
};



// WEBPACK FOOTER //
// ./src/config.js